// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import './assets/css/Custom.css';

function App() {
  return (
    <Router>
      <Header />
        <div style={{ 
          paddingTop: "95px",    // header height
          paddingBottom: "60px"  // footer height
        }}>
        <AppRoutes />
        </div>
      <Footer />
    </Router>
    
  );
}

export default App;
